<template>
<div class="chapter">
<div class="inner_page">
<p class="title1">TAKE <span class="tit">THE</span></p>
<p class="title2">FIRST</p>
<p class="title3">SHOT</p>
<p class="title-para">Strategies to Fire You Up<br/>and Change Your Life</p>
<p class="title-paras">— PART OF THE <span class="big">REVOLUTIONIZE</span><sup>®</sup> SERIES —</p>
<p class="title-author">PEGGY CARUSO</p>
<p class="publisheri"><img alt="image" src="images/pub.png"/></p>
<p class="publisher">NEW YORK</p>
<p class="publishers">LONDON • NASHVILLE • MELBOURNE • VANCOUVER</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?0d146e63